import { Theme } from '@mui/material';

export const chipStyles = (theme: Theme) => ({
  MuiChip: {
    styleOverrides: {
      root: {
        height: 18,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.104px',
      },
      outlinedWarning: {
        border: `1px solid ${theme.palette.warning.main}`,
        color: theme.palette.warning.main,
        backgroundColor: theme.palette.warning.light,
      },
    },
  },
});
